<template>
  <admin-layout :sectionTitle="sectionTitle">
    <!--<div class="page-header">
      <div class="row align-items-end">
        <div class="col-sm mb-2 mb-sm-0">
          <h1 class="page-header-title">{{ this.header }}</h1>
        </div>

        <div class="col-sm-auto">
          <a :href="route('dashboard')" class="btn btn-primary"> Aggiungi immobile </a>
        </div>
      </div>
    </div>-->

    <div class="card agency-properties-index">
      <div class="card-header">
        <div class="row justify-content-between align-items-center flex-grow-1">
          <div class="col-sm-6 col-md-4 mb-3 mb-sm-0">
            <form>
              <!-- Search -->
              <div class="input-group input-group-merge input-group-flush">
                <div class="input-group-prepend">
                  <div class="input-group-text">
                    <i class="tio-search"></i>
                  </div>
                </div>
                <input id="datatableSearch" type="search" class="form-control" placeholder="Cerca immobili" aria-label="Cerca immobili" />
              </div>
              <!-- End Search -->
            </form>
          </div>

          <div class="col-sm-6">
            <div class="d-sm-flex justify-content-sm-end align-items-sm-center">
              <!-- filters -->
              <div class="hs-unfold">
                <a
                  class="js-hs-unfold-invoker btn btn-sm btn-white"
                  href="javascript:;"
                  @click="toggleFilters()"
                  data-hs-unfold-options='{
			                         	"target": "#usersFilterDropdown",
			                         	"type": "css-animation",
			                         	"smartPositionOff": true
			                       	}'
                >
                  Filtri <span class="badge badge-soft-dark rounded-circle ml-1"> {{ filters.length }}</span>
                </a>

                <div v-if="display_filters" class="card position-absolute agency-properties-filter-card property_filters" style="width: 350px">
                  <div class="card-header d-flex justify-content-between">
                    <label>Filtra immobili</label>
                    <span aria-hidden="true" @click="hideFilters()">x</span>
                  </div>

                  <div class="card-body">
                    <div class="card-groups mb-3">
                      <h6 class="text-uppercase">Provenienza</h6>
                      <div class="form-check-inline" style="width: 30%">
                        <label class="form-check-label" for="check1">
                          <input type="radio" class="form-check-input" id="check1" name="type" value="all" checked="" @change="onChange($event, 'property_type')" />Tutti
                        </label>
                      </div>
                      <div class="form-check-inline" style="width: 30%">
                        <label class="form-check-label" for="check2">
                          <input type="radio" class="form-check-input" id="check2" name="type" value="agenzia" @change="onChange($event, 'property_type')" />Agenzia
                        </label>
                      </div>
                      <div class="form-check-inline">
                        <label class="form-check-label" for="check3">
                          <input type="radio" class="form-check-input" id="check3" name="type" value="privato" @change="onChange($event, 'property_type')" />Privato
                        </label>
                      </div>
                    </div>

                    <div class="card-groups mb-3">
                      <h6 class="text-uppercase">Comune</h6>
                      <select class="form-control" @change="onChange($event, 'municipality')">
                        <option value="all" selected="">Tutti</option>
                        <option v-for="municipality in municipalities" :key="municipality.name" :value="municipality.name">{{ municipality.name }}</option>
                      </select>
                    </div>

                    <div class="card-groups mb-3">
                      <h6 class="text-uppercase">Stato Lead</h6>
                      <select class="form-control" @change="onChange($event, 'status')">
                        <option value="all" selected="">Tutti</option>
                        <option v-for="status in this.statusOptions" :key="status.value" :value="status.value">{{ status.label }}</option>
                      </select>
                    </div>

                    <div class="card-groups mb-3">
                      <h6 class="text-uppercase">Stato Deal</h6>
                      <select class="form-control" @change="onChange($event, 'deal_status')">
                        <option value="all" selected="">Tutti</option>
                        <option v-for="deal_status in this.dealStatusOptions" :key="deal_status.value" :value="deal_status.value">{{ deal_status.label }}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <!-- toggles -->
              <div class="hs-unfold ml-3">
                <a
                  class="js-hs-unfold-invoker btn btn-sm btn-white"
                  href="javascript:;"
                  @click="toggleToggles()"
                  data-hs-unfold-options='{
                        "target": "#showHideDropdownToggles",
                        "type": "css-animation",
                        "smartPositionOff": true
                    }'
                >
                  <i class="tio-table"></i>
                </a>

                <div v-show="display_toggles" class="card position-absolute agency-properties-filter-card property_filters" style="width: 350px">
                  <div class="card card-sm">
                    <div class="card-body">
                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="mr-2">Fonte</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_source">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_source" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="mr-2">Partner</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_partner">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_partner" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="mr-2">Ruolo</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_role">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_role" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="mr-2">Committente</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_inserted_by">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_inserted_by" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>

                      <div class="d-flex justify-content-between align-items-center mb-3">
                        <span class="mr-2">Tipologia</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_typology">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_typology" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>

                      <div class="d-flex justify-content-between align-items-center">
                        <span class="mr-2">Stato di fatto</span>
                        <label class="toggle-switch toggle-switch-sm" for="toggleColumn_conditions">
                          <input type="checkbox" class="toggle-switch-input" id="toggleColumn_conditions" />
                          <span class="toggle-switch-label">
                            <span class="toggle-switch-indicator"></span>
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-auto">
                <a :href="route('dashboard')" class="btn btn-primary"> Aggiungi immobile </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive datatable-custom">
        <table
          id="datatable"
          class="table table-lg table-borderless table-thead-bordered table-nowrap table-align-middle card-table"
          data-hs-datatables-options='{
                "columnDefs": [{
                    "targets": [],
                    "orderable": false
                }],
                "scrollY": 500,
                "scrollX": true,
                "scrollCollapse": true,
                "paging": false,
                "order": [],
                "info": {
                    "totalQty": "#datatableWithPaginationInfoTotalQty"
                },
                "bSort": false,
                "search": "#datatableSearch",
                "entries": "#datatableEntries",
                "pageLength": 15,
                "isResponsive": false,
                "isShowPaging": false,
                "pagination": "datatablePagination"
            }'
        >
          <thead class="thead-light">
            <tr>
              <th></th>
              <th>Codice</th>
              <th>Indirizzo</th>

              <!-- ROI -->
              <th>ROI</th>
              <th>% ROI</th>

              <th>Fonte</th>
              <th>Partner</th>
              <th>Ruolo</th>
              <th>Committente</th>
              <th>Tipologia</th>
              <th>Stato di fatto</th>
              <th>Assegnato a</th>
              <th>Note</th>

              <!-- mq [14,15,16,17] -->
              <th>
                <span>MQ</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('mq')">
                  <span v-if="!display_columns.mq.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Locali</th>
              <th class="darker">Bagni</th>
              <th class="darker">Piano</th>
              <th class="darker">Ascensore</th>

              <!-- omi [19,20,21] -->
              <th>
                <span>Prezzo €/mq (min OMI)</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('omi')">
                  <span v-if="!display_columns.omi.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Prezzo €/mq (max OMI)</th>
              <th class="darker">Prezzo €/mq (max Civile Ottimo OMI)</th>
              <th class="darker">Link OMI</th>

              <!-- values -->
              <th>As-is Value</th>
              <th>ARV</th>
              <th>Richiesta</th>

              <!-- prezzo acquisto immobile [26,27,28,29,30,31,32,33,34,35] -->
              <th>
                <span>Prezzo acquisto immobile</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('acquisto_immobile')">
                  <span v-if="!display_columns.acquisto_immobile.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Prezzo immobile</th>
              <th class="darker">Imposte di registro</th>
              <th class="darker">Cessione preliminare</th>
              <th class="darker">Imposte di registro su preliminare</th>
              <th class="darker">Pratiche / Cambi d'uso</th>
              <th class="darker">Debiti condominio</th>
              <th class="darker">Notaio</th>
              <th class="darker">Costi Ammin. & Legali</th>
              <th class="darker">Compenso Delegato</th>
              <th class="darker">Varie</th>

              <!-- Costo commerciale - Acquisto [37,38,39,40] -->
              <th>
                <span>Costo commerciale - Acquisto</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('costo_commerciale')">
                  <span v-if="!display_columns.costo_commerciale.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Provv Agenzia - Acquisto</th>
              <th class="darker">Informatore</th>
              <th class="darker">Costi marketing - Acquisto</th>
              <th class="darker">Altro - Acquisto</th>

              <!-- Costo renovation [42,43,44,45,46,47,48,49] -->
              <th>
                <span>Costo renovation</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('costo_renovation')">
                  <span v-if="!display_columns.costo_renovation.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Edile</th>
              <th class="darker">Serramenti</th>
              <th class="darker">Finiture</th>
              <th class="darker">Arredi</th>
              <th class="darker">Pratiche</th>
              <th class="darker">Direzione Lavori</th>
              <th class="darker">Sicurezza</th>
              <th class="darker">Varie</th>

              <!-- Oneri finanziari [51,52,53] -->
              <th>
                <span>Oneri finanziari</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('oneri_finanziari')">
                  <span v-if="!display_columns.oneri_finanziari.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Assicurazioni</th>
              <th class="darker">FIdeiussioni</th>
              <th class="darker">Mutuo</th>

              <!-- Totale costi acquisto -->
              <th>Totale costi acquisto</th>

              <!-- Prezzo di vendita [56] -->
              <th>
                <span>Prezzo di vendita</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('ricavi_vendita')">
                  <span v-if="!display_columns.ricavi_vendita.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Prezzo di vendita €/mq</th>

              <!-- Costo commerciale - Vendita [58,59,60] -->
              <th>
                <span>Costo commerciale - Vendita</span>
                <button class="btn btn-sm btn-white ml-2 p-0 px-2" @click="toggleColumnsShow('costo_commerciale_vendita')">
                  <span v-if="!display_columns.costo_commerciale_vendita.state">+</span>
                  <span v-else>-</span>
                </button>
              </th>
              <th class="darker">Provv Agenzia - Vendita</th>
              <th class="darker">Costi marketing - Vendita</th>
              <th class="darker">Altro - Vendita</th>

              <!-- Margine commerciale -->
              <th>Margine commerciale</th>

              <!-- actions and status -->
              <!--<th>Semaforo</th>-->
              <th>Stato Deal</th>
              <th>Stato Lead</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="property in this.propertiies" :key="property.id" class="property-row">
              <!-- detail button -->
              <td>
                <button class="detail-button d-none btn btn-xs btn-icon btn-ghost-secondary" @click="toggleDetailModal(true, property)">
                  <i class="tio-open-in-new"></i>
                </button>
              </td>

              <!-- code -->
              <td>
                <strong>{{ property.code }}</strong>
                <br />
                <div>{{ formatDate(property.created_at) }}</div>
              </td>

              <!-- address -->
              <td>
                <strong>{{ fullAddress(property) }}</strong>
                <br />
                <div>{{ property.municipality }}</div>
              </td>

              <!-- diff ROI -->
              <td>€ {{ numf(getDiffROI(property)) }}</td>

              <!-- perc ROI -->
              <td>{{ numf(getPercROI(property)) }} %</td>

              <!-- source -->
              <td>{{ findOptionLabel(sourceOptions, property.source) }}</td>

              <!-- partner -->
              <td>{{ property.partner }}</td>

              <!-- role -->
              <td>{{ property.role }}</td>

              <!-- inserted_by -->
              <td>{{ findOptionLabel(insertedByOptions, property.inserted_by) }}</td>

              <!-- typology -->
              <td>{{ findOptionLabel(typologyOptions, property.typology) }}</td>

              <!-- conditions -->
              <td>{{ findOptionLabel(conditionsOptions, property.conditions) }}</td>

              <!-- assignee -->
              <td>{{ getAssigneeName(property) }}</td>

              <!-- notes -->
              <td>
                <div style="max-width: 15rem; overflow: hidden; text-overflow: ellipsis">{{ property.notes }}</div>
              </td>

              <!-- mq -->
              <td>{{ getPropertyMQ(property) }}</td>
              <td>{{ getPropertyRooms(property) }}</td>
              <td>{{ getPropertyBaths(property) }}</td>
              <td>{{ findOptionLabel(aptFloorOptions, property.floor_number) }}</td>
              <td>{{ property.elevator == 1 ? "SI" : "NO" }}</td>

              <!-- omi -->
              <td>€ {{ numf(property.omi_min) }}</td>
              <td>€ {{ numf(property.omi_max) }}</td>
              <td>€ {{ numf(property.omi_max_civil) }}</td>
              <td>
                <a :href="property.omi_link" target="_blank" class="btn btn-link p-0">{{ property.omi_link == null || property.omi_link == "" ? "" : "Vedi" }}</a>
              </td>

              <!-- values -->
              <td>€ {{ numf(property.actual_agency_price) }}</td>
              <td>€ {{ numf(property.after_restoration_agency_price) }}</td>
              <td>€ {{ numf(property.client_request_price) }}</td>

              <!-- prezzo acquisto immobile -->
              <td>€ {{ numf(getBuyCategoryTotal(property, "acquisto_immobile")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "prezzo_immobile")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "imposte_registro")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "cessione_preliminare")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "imposte_registro_preliminare")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "pratiche_cambio_uso")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "debiti_condominio")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "notaio")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "costi_amministrativi_legali")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "compenso_delegato")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "acquisto_immobile", "varie_1")) }}</td>

              <!-- costo commerciale acquisto -->
              <td>€ {{ numf(getBuyCategoryTotal(property, "costo_commerciale")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_commerciale", "provv_agenzia_acquisto")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_commerciale", "informatore")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_commerciale", "costi_marketing_acquisto")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_commerciale", "altro_2")) }}</td>

              <!-- costo renovation -->
              <td>€ {{ numf(getBuyCategoryTotal(property, "costo_renovation")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "edile")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "serramenti")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "finiture")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "arredi")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "pratiche")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "direzione_lavori")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "sicurezza")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "costo_renovation", "varie_3")) }}</td>

              <!-- oneri finanziari -->
              <td>€ {{ numf(getBuyCategoryTotal(property, "oneri_finanziari")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "oneri_finanziari", "assicurazioni")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "oneri_finanziari", "fideiussioni")) }}</td>
              <td>€ {{ numf(getBuyCategoryField(property, "oneri_finanziari", "mutuo")) }}</td>

              <!-- totale costi acquisto -->
              <td>€ {{ numf(getBuyTotal(property)) }}</td>

              <!-- prezzo di vendita -->
              <td>€ {{ numf(getSellCategoryTotal(property, "ricavi_vendita")) }}</td>
              <td>€ {{ numf(getSellCategoryTotal(property, "ricavi_vendita") / getSellCategoryTotal(property, "ricavi_vendita", true)) }}</td>

              <!-- costo commerciale vendita -->
              <td>€ {{ numf(getSellCategoryTotal(property, "costo_commerciale_vendita")) }}</td>
              <td>€ {{ numf(getSellCategoryField(property, "costo_commerciale_vendita", "provv_agenzia_vendita")) }}</td>
              <td>€ {{ numf(getSellCategoryField(property, "costo_commerciale_vendita", "costi_marketing_vendita")) }}</td>
              <td>€ {{ numf(getSellCategoryField(property, "costo_commerciale_vendita", "altro_6")) }}</td>

              <!-- margine commerciale -->
              <td>€ {{ numf(getSellMargin(property)) }}</td>

              <!-- indicator -->
              <!--<td>
                <span class="legend-indicator legend-indicator-lg" :class="property.semaforo"></span>
              </td>-->

              <!-- deal status -->
              <td>
                <div class="dropdown">
                  <button
                    class="badge-status dropdown-toggle"
                    :class="[findOptionKey(dealStatusOptions, property.deal_status, 'badge')]"
                    type="button"
                    :id="`dropdownMenuButton-deal-${property.id}`"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ findOptionLabel(dealStatusOptions, property.deal_status) }}
                  </button>
                  <div class="dropdown-menu" :aria-labelledby="`dropdownMenuButton-deal-${property.id}`">
                    <a v-for="o in dealStatusOptions" :key="o.value" class="badge-status dropdown-item" :class="o.badge" @click="changePropertyDealStatus(property, o.value)">{{ o.label }}</a>
                  </div>
                </div>
              </td>

              <!-- status -->
              <td>
                <div class="dropdown">
                  <button
                    class="badge-status dropdown-toggle"
                    :class="[findOptionKey(statusOptions, property.status, 'badge')]"
                    type="button"
                    :id="`dropdownMenuButton-${property.id}`"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    {{ findOptionLabel(statusOptions, property.status) }}
                  </button>
                  <div class="dropdown-menu" :aria-labelledby="`dropdownMenuButton-${property.id}`">
                    <a v-for="o in statusOptions" :key="o.value" class="badge-status dropdown-item" :class="o.badge" @click="changePropertyStatus(property, o.value)">{{ o.label }}</a>
                  </div>
                </div>
              </td>

              <!-- actions -->
              <td class="actions">
                <a class="btn btn-sm p-0 btn-link" :href="route('properties.show', property.id)">
                  <i class="tio-visible-outlined"></i>
                </a>
                <a class="btn btn-sm p-0 btn-link" @click="setToDeleteProperty(property.id)" data-toggle="modal" data-target="#properties-delete">
                  <i class="tio-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-footer">
        <div class="row justify-content-center justify-content-sm-between align-items-sm-center">
          <div class="col-sm mb-2 mb-sm-0">
            <div class="d-flex justify-content-center justify-content-sm-start align-items-center">
              <span class="text-secondary">{{ pagination.current_page * pagination.data.length }} di {{ pagination.total }} immobili</span>
            </div>
          </div>

          <div v-if="pagination.per_page < pagination.total" class="col-sm-auto">
            <div class="d-flex justify-content-center justify-content-sm-end">
              <!-- Pagination -->
              <pagination :pagination="pagination" />
            </div>
          </div>
        </div>
      </div>

      <delete-property @delete-property="deleteProperty" :property_id="to_delete_property_id"></delete-property>
      <login-agencies :agencies="agencies" />
    </div>

    <!-- detail modal -->
    <div v-if="detail_property" id="detail-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="detail-modal-title" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <div></div>
            <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
              <i class="tio-clear tio-lg"></i>
            </button>
          </div>
          <div class="modal-body pt-3">
            <div class="detail-modal-title d-flex align-items-center justify-content-between pb-4 mb-4 border-bottom">
              <div>
                <h3 id="detail-modal-title" class="modal-title text-primary">
                  {{ fullAddress(detail_property, true) }}
                </h3>
                <h3 class="m-0 text-secondary">{{ detail_property.code }}</h3>
              </div>
              <a :href="`/admin/properties/${detail_property.id}`" class="btn btn-outline-primary"> Vai alla scheda </a>
            </div>

            <div class="detail-list">
              <!-- deal status -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Status Deal</div>
                <div class="col-8 text-black">
                  <div class="badge-status dropdown-toggle" :class="[findOptionKey(dealStatusOptions, detail_property.deal_status, 'badge')]">
                    {{ findOptionLabel(dealStatusOptions, detail_property.deal_status) }}
                  </div>
                </div>
              </div>

              <!-- status -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Status Lead</div>
                <div class="col-8 text-black">
                  <div class="badge-status dropdown-toggle" :class="[findOptionKey(statusOptions, detail_property.status, 'badge')]">
                    {{ findOptionLabel(statusOptions, detail_property.status) }}
                  </div>
                </div>
              </div>

              <!-- date -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Data</div>
                <div class="col-7 text-black">{{ formatDate(detail_property.created_at) }}</div>
              </div>

              <!-- source -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Fonte</div>
                <div class="col-7 text-black">{{ findOptionLabel(sourceOptions, detail_property.source) }}</div>
              </div>

              <!-- partner -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Partner</div>
                <div class="col-7 text-black">{{ detail_property.partner }}</div>
              </div>

              <!-- role -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Ruolo</div>
                <div class="col-7 text-black">{{ detail_property.role }}</div>
              </div>

              <!-- inserted_by -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Committente</div>
                <div class="col-7 text-black">{{ findOptionLabel(insertedByOptions, detail_property.inserted_by) }}</div>
              </div>

              <!-- typology -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Tipologia</div>
                <div class="col-7 text-black">{{ findOptionLabel(typologyOptions, detail_property.typology) }}</div>
              </div>

              <!-- conditions -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Stato di fatto</div>
                <div class="col-7 text-black">{{ findOptionLabel(conditionsOptions, detail_property.conditions) }}</div>
              </div>

              <!-- deal_status -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Stato Lead</div>
                <div class="col-7 text-black">{{ findOptionLabel(dealStatusOptions, detail_property.deal_status) }}</div>
              </div>

              <!-- assignee -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Assegnato a</div>
                <div class="col-7 text-black">{{ getAssigneeName(detail_property) }}</div>
              </div>

              <!-- notes -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Note</div>
                <div class="col-7 text-black">{{ detail_property.notes }}</div>
              </div>

              <!-- mq -->
              <div class="row detail-row py-2">
                <div class="col-4">MQ</div>
                <div class="col-7 text-black">{{ getPropertyMQ(detail_property) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('mq')">
                    <i v-if="!display_details.mq.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.mq.state" class="row detail-row py-2">
                <div class="col-4">Locali</div>
                <div class="col-7 text-black">{{ getPropertyRooms(detail_property) }}</div>
              </div>
              <div v-if="display_details.mq.state" class="row detail-row py-2">
                <div class="col-4">Bagni</div>
                <div class="col-7 text-black">{{ getPropertyBaths(detail_property) }}</div>
              </div>
              <div v-if="display_details.mq.state" class="row detail-row py-2">
                <div class="col-4">Piano</div>
                <div class="col-7 text-black">{{ findOptionLabel(aptFloorOptions, detail_property.floor_number) }}</div>
              </div>
              <div v-if="display_details.mq.state" class="row detail-row py-2">
                <div class="col-4">Ascensore</div>
                <div class="col-7 text-black">{{ detail_property.elevator == 1 ? "SI" : "NO" }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- omi -->
              <div class="row detail-row py-2">
                <div class="col-4">Prezzo €/mq (min OMI)</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.omi_min) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('omi')">
                    <i v-if="!display_details.omi.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.omi.state" class="row detail-row py-2">
                <div class="col-4">Prezzo €/mq (max OMI)</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.omi_max) }}</div>
              </div>
              <div v-if="display_details.omi.state" class="row detail-row py-2">
                <div class="col-4">Prezzo €/mq (max Civile Ottimo OMI)</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.omi_max_civil) }}</div>
              </div>
              <div v-if="display_details.omi.state" class="row detail-row py-2">
                <div class="col-4">Link OMI</div>
                <div class="col-7 text-black">
                  <a :href="detail_property.omi_link" target="_blank" class="btn btn-primary">{{ detail_property.omi_link == null || detail_property.omi_link == "" ? "" : "Vedi" }}</a>
                </div>
              </div>
              <div class="mb-2"></div>

              <!-- values -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">As-is-value</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.actual_agency_price) }}</div>
              </div>
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">ARV</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.after_restoration_agency_price) }}</div>
              </div>
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Richiesta</div>
                <div class="col-7 text-black">€ {{ numf(detail_property.client_request_price) }}</div>
              </div>

              <!-- prezzo acquisto immobile -->
              <div class="row detail-row py-2">
                <div class="col-4">Prezzo acquisto immobile</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryTotal(detail_property, "acquisto_immobile")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('acquisto_immobile')">
                    <i v-if="!display_details.acquisto_immobile.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Prezzo immobile</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "prezzo_immobile")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Imposte di registro</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "imposte_registro")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Cessione preliminare</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "cessione_preliminare")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Imposte di registro su preliminare</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "imposte_registro_preliminare")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Pratiche / Cambi d'uso</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "pratiche_cambio_uso")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Debiti condominio</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "debiti_condominio")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Notaio</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "notaio")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Costi Ammin. & Legali</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "costi_amministrativi_legali")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Compenso Delegato</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "compenso_delegato")) }}</div>
              </div>
              <div v-if="display_details.acquisto_immobile.state" class="row detail-row py-2">
                <div class="col-4">Varie</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "acquisto_immobile", "varie_1")) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- costo commerciale acquisto -->
              <div class="row detail-row py-2">
                <div class="col-4">Costo commerciale - Acquisto</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryTotal(detail_property, "costo_commerciale")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('costo_commerciale')">
                    <i v-if="!display_details.costo_commerciale.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.costo_commerciale.state" class="row detail-row py-2">
                <div class="col-4">Provv Agenzia - Acquisto</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_commerciale", "provv_agenzia_acquisto")) }}</div>
              </div>
              <div v-if="display_details.costo_commerciale.state" class="row detail-row py-2">
                <div class="col-4">Informatore</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_commerciale", "informatore")) }}</div>
              </div>
              <div v-if="display_details.costo_commerciale.state" class="row detail-row py-2">
                <div class="col-4">Costi marketing - Acquisto</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_commerciale", "costi_marketing_acquisto")) }}</div>
              </div>
              <div v-if="display_details.costo_commerciale.state" class="row detail-row py-2">
                <div class="col-4">Altro - Acquisto</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_commerciale", "altro_2")) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- costo renovation -->
              <div class="row detail-row py-2">
                <div class="col-4">Costo renovation</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryTotal(detail_property, "costo_renovation")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('costo_renovation')">
                    <i v-if="!display_details.costo_renovation.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Edile</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "edile")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Serramenti</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "serramenti")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Finiture</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "finiture")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Arredi</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "arredi")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Pratiche</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "pratiche")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Direzione Lavori</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "direzione_lavori")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Sicurezza</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "sicurezza")) }}</div>
              </div>
              <div v-if="display_details.costo_renovation.state" class="row detail-row py-2">
                <div class="col-4">Varie</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "costo_renovation", "varie_3")) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- oneri finanziari -->
              <div class="row detail-row py-2">
                <div class="col-4">Oneri finanziari</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryTotal(detail_property, "oneri_finanziari")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('oneri_finanziari')">
                    <i v-if="!display_details.oneri_finanziari.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.oneri_finanziari.state" class="row detail-row py-2">
                <div class="col-4">Assicurazioni</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "oneri_finanziari", "assicurazioni")) }}</div>
              </div>
              <div v-if="display_details.oneri_finanziari.state" class="row detail-row py-2">
                <div class="col-4">FIdeiussioni</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "oneri_finanziari", "fideiussioni")) }}</div>
              </div>
              <div v-if="display_details.oneri_finanziari.state" class="row detail-row py-2">
                <div class="col-4">Mutuo</div>
                <div class="col-7 text-black">€ {{ numf(getBuyCategoryField(detail_property, "oneri_finanziari", "mutuo")) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- totale costi acquisto -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Totale costi acquisto</div>
                <div class="col-7 text-black">€ {{ numf(getBuyTotal(detail_property)) }}</div>
              </div>

              <!-- prezzo di vendita -->
              <div class="row detail-row py-2">
                <div class="col-4">Prezzo di vendita</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryTotal(detail_property, "ricavi_vendita")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('ricavi_vendita')">
                    <i v-if="!display_details.ricavi_vendita.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.ricavi_vendita.state" class="row detail-row py-2">
                <div class="col-4">Prezzo di vendita €/MQ</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryTotal(detail_property, "ricavi_vendita") / getSellCategoryTotal(detail_property, "ricavi_vendita", true)) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- costo commerciale vendita -->
              <div class="row detail-row py-2">
                <div class="col-4">Costo commerciale - Vendita</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryTotal(detail_property, "costo_commerciale_vendita")) }}</div>
                <div class="col-1">
                  <button class="btn btn-xs btn-icon btn-ghost-primary" @click="toggleDetailSection('costo_commerciale_vendita')">
                    <i v-if="!display_details.costo_commerciale_vendita.state" class="tio-add"></i>
                    <i v-else class="tio-remove"></i>
                  </button>
                </div>
              </div>
              <div v-if="display_details.costo_commerciale_vendita.state" class="row detail-row py-2">
                <div class="col-4">Provv Agenzia - Vendita</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryField(detail_property, "costo_commerciale_vendita", "provv_agenzia_vendita")) }}</div>
              </div>
              <div v-if="display_details.costo_commerciale_vendita.state" class="row detail-row py-2">
                <div class="col-4">Costi marketing - Vendita</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryField(detail_property, "costo_commerciale_vendita", "costi_marketing_vendita")) }}</div>
              </div>
              <div v-if="display_details.costo_commerciale_vendita.state" class="row detail-row py-2">
                <div class="col-4">Altro - Vendita</div>
                <div class="col-7 text-black">€ {{ numf(getSellCategoryField(detail_property, "costo_commerciale_vendita", "altro_6")) }}</div>
              </div>
              <div class="mb-2"></div>

              <!-- margine commerciale -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">Margine commerciale</div>
                <div class="col-7 text-black">€ {{ numf(getSellMargin(detail_property)) }}</div>
              </div>

              <!-- diff ROI -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">ROI</div>
                <div class="col-7 text-black">€ {{ numf(getDiffROI(detail_property)) }}</div>
              </div>

              <!-- perc ROI -->
              <div class="row detail-row mb-2 py-2">
                <div class="col-4">% ROI</div>
                <div class="col-7 text-black">€ {{ numf(getPercROI(detail_property)) }}</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-white" data-dismiss="modal">Chiudi</button>
          </div>
        </div>
      </div>
    </div>
  </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import Pagination from "@/Layouts/Partials/Pagination";
import Label from "@/Jetstream/Label";
import Input from "@/Jetstream/Input";
import DeleteProperty from "@/Pages/Admin/Properties/Delete";
import LoginAgencies from "@/Pages/Admin/Properties/LoginAgencies";
import { DateTime } from "luxon";
import {
  findOptionLabel,
  findOptionKey,
  typology_options,
  status_options,
  inserted_by_options,
  conditions_options,
  deal_status_options,
  apt_floor_options,
  source_options
} from "../../../helpers/select-options";
import BpCalcs from "./BusinessPlan/bp-calcs";
import { numf } from "@/helpers/helper";

export default {
  components: {
    LoginAgencies,
    Input,
    Label,
    AdminLayout,
    Pagination,
    DeleteProperty
  },

  props: ["properties", "municipalities", "agencies","sectionTitle"],

  mounted() {
    this.datatable = $.HSCore.components.HSDatatables.init($("#datatable"));
    const self = this;

    self.datatable.columns(5).visible(false);
    $("#toggleColumn_source").change(function(e) {
      self.datatable.columns(5).visible(e.target.checked);
    });

    self.datatable.columns(6).visible(false);
    $("#toggleColumn_partner").change(function(e) {
      self.datatable.columns(6).visible(e.target.checked);
    });

    self.datatable.columns(7).visible(false);
    $("#toggleColumn_role").change(function(e) {
      self.datatable.columns(7).visible(e.target.checked);
    });

    self.datatable.columns(8).visible(false);
    $("#toggleColumn_inserted_by").change(function(e) {
      self.datatable.columns(8).visible(e.target.checked);
    });

    self.datatable.columns(9).visible(false);
    $("#toggleColumn_typology").change(function(e) {
      self.datatable.columns(9).visible(e.target.checked);
    });

    self.datatable.columns(10).visible(false);
    $("#toggleColumn_conditions").change(function(e) {
      self.datatable.columns(10).visible(e.target.checked);
    });

    this.toggleColumnsShow("all", false);

    this.getReportRooms(this.properties.data[1]);
  },

  data() {
    return {
      header: !this.isOutOfZone() ? "Immobili zona attiva" : "Immobili fuori zona",
      aptFloorOptions: apt_floor_options,
      statusOptions: status_options,
      dealStatusOptions: deal_status_options,
      insertedByOptions: inserted_by_options,
      conditionsOptions: conditions_options,
      typologyOptions: typology_options,
      sourceOptions: source_options,
      semaforos: [
        { index: 1, label: "Verde", value: "bg-success" },
        { index: 1, label: "Giallo", value: "bg-warning" },
        { index: 1, label: "Rosso", value: "bg-danger" }
      ],
      renderComponent: true,
      key: 0,
      propertiies: this.properties.data,
      pagination: this.properties,
      filters: [],
      to_delete_property_id: null,
      display_filters: false,
      display_toggles: false,
      display_columns: {
        mq: { state: false, cols: [14, 15, 16, 17] },
        omi: { state: false, cols: [19, 20, 21] },
        acquisto_immobile: { state: false, cols: [26, 27, 28, 29, 30, 31, 32, 33, 34, 35] },
        costo_commerciale: { state: false, cols: [37, 38, 39, 40] },
        costo_renovation: { state: false, cols: [42, 43, 44, 45, 46, 47, 48, 49] },
        oneri_finanziari: { state: false, cols: [51, 52, 53] },
        ricavi_vendita: { state: false, cols: [56] },
        costo_commerciale_vendita: { state: false, cols: [58, 59, 60] }
      },
      display_details: {
        mq: { state: false },
        omi: { state: false },
        acquisto_immobile: { state: false },
        costo_commerciale: { state: false },
        costo_renovation: { state: false },
        oneri_finanziari: { state: false },
        ricavi_vendita: { state: false },
        costo_commerciale_vendita: { state: false }
      },
      datatable: null,
      detail_property: this.properties.data.length > 0 ? this.properties.data[0] : null
    };
  },

  methods: {
    findOptionLabel,
    findOptionKey,
    numf,

    getPropertyRooms(property) {
      const arr = this.getReportRooms(property).filter(r => r.tipo_composizione != 1);
      if (arr.length) return arr.length;
      return 0;
    },

    getPropertyBaths(property) {
      const arr = this.getReportRooms(property).filter(r => r.tipo_composizione == 1);
      if (arr.length) return arr.length;
      return 0;
    },

    getPropertyMQ(property) {
      const arr = this.getReportRooms(property).map(r => r.mq);
      if (arr.length) return arr.reduce((p, n) => (p == null ? Number(n) : Number(p) + Number(n)));
      return 0;
    },

    getReportRooms(property) {
      const rooms = [];
      if (property.report) {
        const sections = property.report.categories.composizione_immobile.sections;
        const section = sections[0];
        section.data.forEach(r => rooms.push(r));
      }
      return rooms;
    },

    getPercROI(property) {
      return (this.getDiffROI(property) / this.getBuyTotal(property)) * 100;
    },
    getDiffROI(property) {
      return this.getSellMargin(property) - this.getBuyTotal(property);
    },
    bpCalcs(property) {
      return new BpCalcs(property.business_plan);
    },
    getBuyCategory(property, catKey) {
      const bpC = this.bpCalcs(property);
      return bpC.getBuyCategory(catKey);
    },
    getBuyCategoryField(property, catKey, fieldKey) {
      const cat = this.getBuyCategory(property, catKey);
      const bpC = this.bpCalcs(property);
      const f = cat.fields.find(f => f.field.name == fieldKey);
      if (bpC.checkFieldComputedSecondary(f)) return bpC.getComputedSecondaryValue(f);
      if (f) return bpC.getFieldValue(f);
      return 0;
    },
    getBuyCategoryTotal(property, catKey) {
      const cat = this.getBuyCategory(property, catKey);
      if (!cat) return 0;
      const bpC = this.bpCalcs(property);
      return bpC.getCategoryTotal(cat);
    },
    getSellCategory(property, catKey) {
      const bpC = this.bpCalcs(property);
      return bpC.getSellCategory(catKey);
    },
    getSellCategoryField(property, catKey, fieldKey) {
      const cat = this.getSellCategory(property, catKey);
      const bpC = this.bpCalcs(property);
      const f = cat.fields.find(f => f.field.name == fieldKey);
      if (bpC.checkFieldComputedSecondary(f)) return bpC.getComputedSecondaryValue(f);
      if (f) return bpC.getFieldValue(f);
      return 0;
    },
    getSellCategoryTotal(property, catKey, unitsMQ = false) {
      const cat = this.getSellCategory(property, catKey);
      if (!cat) return 0;
      const bpC = this.bpCalcs(property);
      return bpC.getCategoryTotal(cat, unitsMQ);
    },
    getSellMargin(property) {
      return this.bpCalcs(property).getSellMargin();
    },
    getBuyTotal(property) {
      return this.bpCalcs(property).getBuyTotal();
    },

    toggleColumnsShow(key = "all", state = null) {
      if (key == "all") {
        for (const k in this.display_columns) {
          const section = this.display_columns[k];
          this.toggleSectionColumns(section, state);
        }
        return;
      }

      const section = this.display_columns[key];
      this.toggleSectionColumns(section, state);
    },
    toggleSectionColumns(section, state) {
      if (state !== null) {
        section.state = state;
      } else {
        section.state = !section.state;
      }
      const self = this;
      section.cols.forEach(c => self.datatable.columns(c).visible(section.state));
    },

    getAssigneeName(property) {
      if (property.assignee) return property.assignee.name;
      return "";
    },

    formatDate(date) {
      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_FULL);
    },
    fullAddress(property, withMunicipality) {
      const addressArray = [];
      if (property.address != null) addressArray.push(property.address);
      if (property.house_number != null) addressArray.push(property.house_number);
      if (withMunicipality && property.municipality != null) addressArray.push(property.municipality);
      if (withMunicipality && property.country != null) addressArray.push(property.country);
      return addressArray.join(", ");
    },

    isOutOfZone() {
      return window.location.href.includes("fuori-zona");
    },

    changePropertyStatus(property, status) {
      axios
        .put(route("properties.update", property.id), {
          status: status
        })
        .catch(error => {
          console.log(error);
        });

      property.status = status;
    },

    changePropertyDealStatus(property, deal_status) {
      axios
        .put(route("properties.update", property.id), {
          deal_status: deal_status
        })
        .catch(error => {
          console.log(error);
        });

      property.deal_status = deal_status;
    },

    setToDeleteProperty(id) {
      this.to_delete_property_id = id;
    },

    deleteProperty(id) {
      axios.delete(route("properties.destroy", id)).catch(error => {
        console.log(error);
      });

      const index = this.propertiies.findIndex(property => property.id === id);

      if (~index) this.propertiies.splice(index, 1);

      $("#properties-delete").modal("hide");

      this.$toast.success("Immobile eliminato con successo");
    },

    onChange(event, type) {
      let url = !this.isOutOfZone() ? route("properties.index") : route("properties.out_of_zone");
      let data = {};

      if (type === "status") {
        data = { search_status: event.target.value };
      } else if (type === "deal_status") {
        data = { search_deal_status: event.target.value };
      } else if (type === "municipality") {
        data = { search_municipality: event.target.value };
      } else if (type === "semaforo") {
        data = { semaforo: event.target.value };
      } else {
        data = { search_property_type: event.target.value };
      }

      if (event.target.value === "all") {
        const index = this.filters.findIndex(filter => filter.type === type);

        if (~index) this.filters.splice(index, 1);
      } else {
        const index = this.filters.findIndex(filter => filter.type === type);

        if (!~index) {
          this.filters.push({
            type: type,
            value: event.target.value
          });
        } else {
          let selected_filter = this.filters.filter(filter => filter.type === type);

          selected_filter[0].value = event.target.value;
        }
      }

      if (type !== "semaforo") {
        axios
          .get(url, {
            params: data
          })
          .then(response => {
            this.propertiies = response.data.data;
            this.pagination = response.data;
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        if (event.target.value === "all") {
          this.propertiies = this.properties.data;
        } else {
          this.propertiies = this.properties.data.filter(property => {
            return property.semaforo === event.target.value;
          });
        }
      }
    },

    toggleFilters() {
      this.display_filters === true ? (this.display_filters = false) : (this.display_filters = true);
    },

    toggleToggles() {
      this.display_toggles = !this.display_toggles;
    },

    hideFilters() {
      this.display_filters = false;
    },

    toggleDetailModal(open, property) {
      if (open) {
        this.detail_property = property;
        $("#detail-modal").modal("show");
      } else {
        $("#detail-modal").modal("hide");
      }
    },

    toggleDetailSection(key, state = null) {
      if (state == null) state = !this.display_details[key].state;
      this.display_details[key].state = state;
    }
  }
};
</script>

<style lang="scss">
// .DTFC_ScrollWrapper {
//   min-height: 44rem;
// }
// .dataTables_scrollBody {
//   min-height: 44rem;
// }
// .dataTables_scroll {
//   min-height: 40rem;
// }

table {
  .actions {
    min-width: 5.5rem;
  }

  th {
    &:first-child {
      min-width: 3rem;
    }

    &.darker {
      background-color: #e7e7e7 !important;
    }
  }

  td {
    background-color: #fff !important;

    &:first-child {
      min-width: 3rem;
      padding-right: 0 !important;
    }

    &.darker {
      background-color: #f0f0f0 !important;
    }
  }

  tr.property-row {
    &:hover {
      td {
        background-color: #f5f5f5 !important;

        .detail-button {
          display: block !important;
        }
      }
    }
  }
}

#detail-modal {
  .detail-list {
    .detail-row {
      background-color: #f0f0f0;

      .text-black {
        color: black;
      }
    }
  }
}

// .agency-properties-index {
//     max-height: calc(100vh - 27rem);
// }

</style>
